// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import store, { persistor } from './store';
import App from './App';
import { ProductProvider } from './providers/ProductContext';
import { AuthProvider } from './providers/AuthContext';
import { ProductTagProvider } from './providers/ProductTagContext';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/globals.css';
import './styles/ProductoAI.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <HelmetProvider>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <ProductProvider>
            <ProductTagProvider>
              <AuthProvider>
                <App />
              </AuthProvider>
            </ProductTagProvider>
          </ProductProvider>  
        </PersistGate>
      </Provider>
    </HelmetProvider>
  </React.StrictMode>
);
